import { Fragment, useState, useEffect } from "react"
import {useTranslation} from 'react-i18next';

import HtmlInput from './HtmlInput';

const EmailComponent = ({setFormErrors, setFormValues, formErrors}) => {
  const {t: translate } = useTranslation();
  const emailFields = {
      email: '',
      emailConfirm: '',
  };

  const [emailVals, setEmailVals] = useState(emailFields);
  const [emailErrors, setEmailErrors] = useState(formErrors);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (Object.prototype.hasOwnProperty.call(emailErrors, name)) {
      //reset errors
      setEmailErrors({});
      setFormErrors((prevState) => ({
        ...prevState,
        [name]: null
      }));
    }

    setEmailVals({
      ...emailVals,
      [name]: value,
    });
  };

  const checkEmailsMatch = () => {
    if( emailVals.email === '' ) {
      setEmailErrors((prevState) => ({
        ...prevState,
        email: translate('email-required'),
      }));

      return;
    }
    if (emailVals.emailConfirm !== emailVals.email) {
        setEmailErrors((prevState) => ({
          ...prevState,
          emailConfirm: translate('email-mismatch'),
        }));

        return false;
    } else {
      setEmailErrors(
        Object.entries(emailErrors).filter(
          ([key]) => key !== 'emailConfirm',
        ),
      );

      return true;
    }
  };

  useEffect(() => {
    if (emailVals.emailConfirm === '') {
      setFormErrors((prevState) => ({
        ...prevState,
        emailConfirm: translate('confirm-email')
      }));
    }

    if (emailVals.email !== '') {
      setFormValues((prevState) => ({
        ...prevState,
        email: emailVals.email
      }));
    }
    
    if (emailVals.emailConfirm !== '') {
      if( checkEmailsMatch() )  {
        setFormValues((prevState) => ({
          ...prevState,
          emailConfirm: emailVals.emailConfirm
        }));
      }
    }
  }, [emailVals]);

  useEffect(() => {
    if( formErrors.email ) {
      setEmailErrors((prevState) => ({
        ...prevState,
        email: formErrors.email
      }));
    }
    
    if( formErrors.emailConfirm && emailVals.emailConfirm !== '' ) {
      setEmailErrors((prevState) => ({
        ...prevState,
        emailConfirm: formErrors.emailConfirm
      }));
    }
  }, [formErrors])

  return (
      <Fragment>
          <div
              className={`input-row input-row--half ${
              emailErrors.email ? 'input-row--error' : ''
              }`}
          >
              <HtmlInput 
                  type={'email'}
                  id='email'
                  name="email"
                  legend={translate('your-email')}
                  value={emailVals.email}
                  changeCallback={handleChange}
                  mouseDownCallback={checkEmailsMatch}
                  blurCallback={checkEmailsMatch}
                  hasErrors={'email' in emailErrors}
              />
              {emailErrors.email && (
                  <p className="input-row__error">{emailErrors.email}</p>
              )}
          </div>
          <div
              className={`input-row input-row--half ${
              emailErrors.emailConfirm ? 'input-row--error' : ''
              }
              ${emailErrors.email ? 'input-row--disabled' : ''}
              `}
          >
              <HtmlInput
                  type={'email'}
                  id='emailConfirm'
                  name="emailConfirm"
                  legend={translate('repeat-email')}
                  value={emailVals.emailConfirm}
                  changeCallback={handleChange}
                  hasErrors={'emailConfirm' in emailErrors}
                  blurCallback={checkEmailsMatch}
              />
              {emailErrors.emailConfirm && (
              <p className="input-row__error">{emailErrors.emailConfirm}</p>
              )}
          </div>
      </Fragment>
  )
}

export default EmailComponent;
